/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { createResource, type RouteResource } from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { getOgConsolidationUserState } from './getOgConsolidationUserState.tsx';
import type { OgConsolidationUserState } from './OgConsolidationUserState.types.tsx';

const RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
export const consolidationUserStateResource: RouteResource<OgConsolidationUserState> =
	createResource<OgConsolidationUserState>({
		type: 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE',
		getKey: () => RESOURCE_KEY,
		getData: (_, { tenantContext: { atlassianAccountId: accountId } }) =>
			getOgConsolidationUserState(accountId).catch((error) => {
				fireErrorAnalytics({
					meta: {
						id: 'consolidationUserStateResource',
						packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
						teamName: 'alexstrasza',
					},
					error,
					sendToPrivacyUnsafeSplunk: true,
				});
				throw error;
			}),
		maxAge: Infinity,
		isCritical: true,
	});
